export * from './resizable.module';
 // tslint:disable-line
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-resizable-element/dist/esm/src/index.js
// module id = 1267
// module chunks = 4